/* Leaflet is bundled locally. Only visible basemap tiles are requested from OSM. */
'use strict';
const LocationMap = (() => {
 const coordinates=p=>`${Math.abs(p.lat).toFixed(5)}° ${p.lat<0?'S':'N'}, ${Math.abs(p.lng).toFixed(5)}° ${p.lng<0?'W':'E'}`;
 function create(container,onPick){
  const note=document.querySelector('#custom-map-note');
  if(!window.L){container.textContent='The map couldn’t load. You can still find your place using the search above.';return null;}
  container.textContent='';
  const map=L.map(container,{scrollWheelZoom:false,minZoom:3,maxZoom:17,worldCopyJump:true}).setView([48.15,-123.05],7);
  const tiles=L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',{
   maxZoom:17,attribution:'&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
  }).addTo(map);
  const icon=L.divIcon({className:'salish-map-pin',html:'<span aria-hidden="true"></span>',iconSize:[30,40],iconAnchor:[15,40]});
  let marker=null,point=null,alive=true;
  const select=latlng=>{
   if(!alive)return;
   const wrapped=latlng.wrap(),p={lat:Number(wrapped.lat.toFixed(5)),lng:Number(wrapped.lng.toFixed(5))};
   if(!LocationSearch.validPoint(p))return;
   setLocation(p,false);onPick(p);
  };
  function setLocation(p,center=true){
   point=p;
   if(!p){if(marker){marker.remove();marker=null;}return;}
   if(!marker){
    marker=L.marker([p.lat,p.lng],{icon,draggable:true,autoPan:true,title:'Your shoreline pin. Drag to adjust.',alt:'Your shoreline pin'}).addTo(map);
    marker.on('dragend',()=>select(marker.getLatLng()));
    marker.getElement()?.setAttribute('aria-label','Your shoreline pin. Drag to adjust, or pan the map and use its center.');
   }else marker.setLatLng([p.lat,p.lng]);
   if(center)map.setView([p.lat,p.lng],Math.max(map.getZoom(),12),{animate:false});
  }
  map.on('click',e=>select(e.latlng));
  tiles.on('tileerror',()=>{if(alive&&note){note.textContent='Some map tiles couldn’t load. Search still works; try reloading the map.';document.querySelector('#custom-map-retry').hidden=false;}});
  return {
   setLocation,
   useCenter:()=>select(map.getCenter()),
   recenter:()=>{if(point)map.setView([point.lat,point.lng],Math.max(map.getZoom(),12),{animate:false});},
   retry:()=>{tiles.redraw();if(note)note.textContent='Tap the shoreline or drag your pin. To use a keyboard, focus the map, move with arrow keys, then choose “Use map center.”';document.querySelector('#custom-map-retry').hidden=true;},
   destroy:()=>{alive=false;map.remove();}
  };
 }
 return {create,coordinates};
})();
